import yup from 'utils/yup';

const getValidationSchema = (isSubUser) => {
  const defaultConfig = {
    firstName: yup.string().required(),
    lastName: yup.string().required(),
    contactPhone: yup.string().required(),
    password: yup.string().requirements().required(),
    passwordConfirmation: yup.string().passwordConfirmed().required(),
    accept: yup.bool().agreed(),
  };

  const accountAdminConfig = {
    companyName: yup.string().required(),
    country: yup.string().required().nullable(),
  };

  return yup.object({
    ...defaultConfig,
    ...(!isSubUser && accountAdminConfig),
  });
};

export default getValidationSchema;
